export default "<login-widget params=\"dataProvider: dataProvider, route: route\"></login-widget>\n";